import { render, staticRenderFns } from "./actionsMenu.vue?vue&type=template&id=0972c00c&lang=pug&"
import script from "./actionsMenu.vue?vue&type=script&lang=js&"
export * from "./actionsMenu.vue?vue&type=script&lang=js&"
import style0 from "vue-dialog-drag/dist/vue-dialog-drag.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./actionsMenu.vue?vue&type=style&index=1&id=0972c00c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports